
import { REGEXP } from '@/constants/regexp';

export default {
  business_unit_id: {
    name: 'business_unit_id',
    title: '业务单元ID',
    type: 'search',
    config: {
      placeholder: '请输入业务单元ID',
    },
    rules: [
      {
        pattern: REGEXP.number,
        message: '请输入数字类型，形如：100',
      },
    ],
  },
  business_unit_name: {
    name: 'business_unit_name',
    title: '业务单元名称',
    type: 'search',
    config: {
      placeholder: '请输入业务单元名称',
    },
  },
  contract_no: {
    name: 'contract_no',
    title: '合同编号',
    type: 'search',
    config: {
      placeholder: '请输入合同编号',
    },
  },
  contract_status: {
    name: 'contract_status',
    title: '合同状态',
    type: 'select',
    config: {
      clear: true,
      data: [],
      placeholder: '请选择合同状态',
    },
  },
  contract_type: {
    name: 'contract_type',
    title: '合同类型',
    type: 'select',
    config: {
      clear: true,
      data: [],
      placeholder: '请选择合同类型',
    },
  },
};
